import Checkbox from './Checkbox.jsx';

export {
  Checkbox
}


// WEBPACK FOOTER //
// ./components/partials/checkbox/index.js